import { helpers } from 'vuelidate/lib/validators';

function convertDate(dateConvert) {
  const year = dateConvert.getUTCFullYear();
  const month = `0${dateConvert.getMonth() + 1}`.slice(-2);
  const day = `0${dateConvert.getDate()}`.slice(-2);

  return `${year}-${month}-${day}`;
}

export function isEmpty(data) {
  return data == null || data == '' || data == undefined;
}

export function text(data) {
  if (data == null || data == '' || data == undefined) {
    return '( not set )';
  }
  return data;
}

export function getTommorowDate(days) {
  const dateObj = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(dateObj.getDate() + days);
  const dateTommorrow = convertDate(tomorrow);
  return dateTommorrow;
}

export function getDate(days, dateData) {
  const dateObj = new Date(dateData);
  const newDate = new Date(dateData);
  newDate.setDate(dateObj.getDate() + days);
  const dateTommorrow = convertDate(newDate);
  return dateTommorrow;
}

function getDateNow() {
  const dateObj = new Date();
  const year = dateObj.getUTCFullYear();
  const month = `0${dateObj.getMonth() + 1}`.slice(-2);
  const day = `0${dateObj.getDate()}`.slice(-2);

  return `${year}-${month}-${day}`;
}

export function formatDate(dateVal) {
  if (!dateVal) return null;

  const [year, month, day] = dateVal.split('-');
  return `${day}/${month}/${year}`;
}
export function parseDate(dateVal) {
  if (!dateVal || typeof dateVal !== 'string') return null;

  const parts = dateVal.split('/');
  if (parts.length !== 3) return null;

  const [day, month, year] = parts;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}


export const atob = (str) => Buffer.from(str, 'base64').toString('binary');

export const btoa = (str) => Buffer.from(str, 'binary').toString('base64');

export const date = getDateNow();

export const showAlert = (ctx, message, icon, color, statusData = true) => {
  ctx.commit(
    'setSnackbar',
    {
      status: statusData,
      message,
      icon,
      color,
    },
    { root: true }
  );
};

export function checkRangeDate(dateData, dateModel) {
  dateData.sort();
  if (dateData.length == 1) {
    dateData.push(dateModel);
  }
}

export const regexDoesNotContainPipe = helpers.regex(
  'doesNotContainPipe',
  /^(?:(?!\|).)*$/
);

export const regexNumericDecimal = helpers.regex(
  'numeric',
  /^(100|(\d\d?))(\.\d{1,2})?$/
);

export const regexNumericDecimalOne = helpers.regex(
  'numeric',
  /^(100|0|[1-9]\d{0,9})(\.\d{1,2})?$/
);

export const regexAlphanumChar = helpers.regex(
  'alphanumChar',
  /^[a-z0-9* ]*$/i
);

export const regexNumberValidate = helpers.regex('numberValidate', /[^0-9 *$]/);

export const checkRegexAlphanumChar = (val) => {
  const regex = /^[a-z0-9* ]*$/i;
  return regex.test(val);
};

export const checkRegexDoesNotContainPipe = (val) => {
  const regex = /^(?:(?!\|).)*$/;
  return regex.test(val);
};
